export const getAvailableLanguages = (state) => state.app.get('availableLanguages');

export const getSelectedLanguage = (state) => state.app.get('selectedLanguage');
